/** Valeurs persistées sous `secteurActivite` (profil tenant, onboarding). */
export const SECTEUR_ACTIVITE_OPTIONS = [
  { value: "", label: "Choisir… (optionnel)" },
  { value: "ecomm", label: "E-commerce (vente en ligne)" },
  { value: "saas", label: "SaaS / Logiciel" },
  { value: "conseil", label: "Conseil / Consulting" },
  { value: "marketing", label: "Agence marketing / communication" },
  { value: "asso", label: "Association / Fondation" },
  { value: "retail", label: "Commerce physique + digital" },
  { value: "autre", label: "Autre activité digitale" },
];
